__turbopack_context__.v({
  "card": "component-module__wVywga__card",
});
